









































































import Header from '@/components/common/Header.vue';
import { Component, Vue } from 'vue-property-decorator';
import { workspaceService } from '@/services/WorkspaceService';
import { registrationService } from '@/services/RegistrationService';

@Component({
  components: {
    Header,
  },
})
export default class WorkspaceSwitch extends Vue {
  workspaces: any = [];
  invitations: any = [];
  inactiveWorkspaceExists: boolean = false;
  isModalShown: boolean = false;
  isLoading = false;

  mounted() {
    this.getWorkspaceList();
  }
  getWorkspaceList() {
    workspaceService
      .getWorkspaces()
      .then((data: any) => {
        this.workspaces = data.workspaces || [];
        this.workspaces.sort((a: any, b: any) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        this.workspaces.forEach((workspace: any) => {
          if (workspace.activated === false) {
            this.inactiveWorkspaceExists = true;
          }
        });
        this.invitations = data.invitations || [];
        this.invitations = this.invitations.map((item: any) => {
          item.isLoading = false;
          return item;
        });
      })
      .catch(() => {});
  }
  goToCreateNewWorkspace() {
    if (this.inactiveWorkspaceExists) {
      this.isModalShown = true;
    } else {
      this.$router.push(`/new-workspace`).catch(() => {});
    }
  }
  onClose() {
    this.isModalShown = false;
  }
  acceptInvitation(workspace: any) {
    if (workspace.isLoading) {
      return;
    }
    workspace.isLoading = true;
    this.invitations = [...this.invitations];
    registrationService
      .acceptInvitation(workspace.token)
      .then(() => {
        workspace.isLoading = false;
        this.getWorkspaceList();
      })
      .catch(() => {
        workspace.isLoading = false;
      });
  }
  removeInvitation(workspace: any) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .removeInvitation(workspace.token)
      .then(() => {
        this.isLoading = false;
        this.getWorkspaceList();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  chooseWorkspace(workspace: any) {
    if (workspace.activated === true) {
      this.$router.push(`/workspaces/${workspace.id}`).catch(() => {});
    } else {
      this.$router.push(`/workspaces/${workspace.id}/select-payment-method`).catch(() => {});
    }
  }
  chooseWorkspaceSettings(workspace: any) {
    if (workspace.activated === true) {
      this.$router
        .push({
          path: `/workspaces/${workspace.id}/settings`,
          query: { back: this.$route.fullPath },
        })
        .catch(() => {});
    } else {
      this.$router.push(`/workspaces/${workspace.id}/select-payment-method`).catch(() => {});
    }
  }
  showBlockedWorkspaceInfo(workspace: any) {
    const index = this.workspaces.findIndex((item: any) => item.id === workspace.id);
    this.workspaces[index].blockedInfo = true;
    this.workspaces = [...this.workspaces];
  }
  hideBlockedWorkspaceInfo(workspace: any) {
    const index = this.workspaces.findIndex((item: any) => item.id === workspace.id);
    this.workspaces[index].blockedInfo = false;
    this.workspaces = [...this.workspaces];
  }
}
